import { useEffect } from 'react'
import { useBookingContext } from './BookingContext'
import ProgressIndicator from './components/ProgressIndicator'
import ServiceSelectionStep from './steps/ServiceSelectionStep'
import DateTimeStep from './steps/DateTimeStep'
import ContactStep from './steps/ContactStep'
import ConfirmStep from './steps/ConfirmStep'
import SuccessStep from './steps/SuccessStep'

export default function BookingWidget() {
  const { config, currentStep, loadServices, loadAvailability } = useBookingContext()

  useEffect(() => {
    // Load services and availability in parallel on mount
    loadServices()

    const now = new Date()
    loadAvailability(now.getFullYear(), now.getMonth())
  }, [])

  return (
    <div className="w-full max-w-6xl mx-auto p-4 md:p-8">
      {/* Header */}
      <div className="mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
          Schedule your service with {config.businessInfo.name}
        </h1>
        <p className="text-muted-foreground">
          Book your appointment in just a few simple steps
        </p>
      </div>

      {/* Progress Indicator */}
      {currentStep !== 'success' && (
        <div className="mb-12">
          <ProgressIndicator currentStep={currentStep} />
        </div>
      )}

      {/* Step Content */}
      <div className="min-h-[650px]">
        {currentStep === 'service' && (
          <div className="animate-in fade-in slide-in-from-right-4 duration-500">
            <ServiceSelectionStep />
          </div>
        )}
        {currentStep === 'datetime' && (
          <div className="animate-in fade-in slide-in-from-right-4 duration-500">
            <DateTimeStep />
          </div>
        )}
        {currentStep === 'contact' && (
          <div className="animate-in fade-in slide-in-from-right-4 duration-500">
            <ContactStep />
          </div>
        )}
        {currentStep === 'confirm' && (
          <div className="animate-in fade-in slide-in-from-right-4 duration-500">
            <ConfirmStep />
          </div>
        )}
        {currentStep === 'success' && (
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <SuccessStep />
          </div>
        )}
      </div>
    </div>
  )
}
